module.exports = __webpack_public_path__ + "tc.13ee6b879cd11251a2a5.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/tc.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/tc.svg
// module chunks = styles